// extracted by mini-css-extract-plugin
module.exports = {"contacts":"Contacts_contacts___jZjH","contacts__title":"Contacts_contacts__title__2ZupM","contacts__content":"Contacts_contacts__content__VOU0K"};